module.exports = __webpack_public_path__ + "static/media/favicon.80f10f3d.ico";